<template>
  <table class="table table-sm table-bordered table-striped">
			<thead style="position: sticky; top: 0">									
				<tr style="overflow:hidden;">
					<td>Fecha    </td>
					<td>Operación</td>
					<td>Sucursal </td>
				</tr>
			</thead>
                          
			<tbody style="text-align: left;">
				<tr  v-for="remito in seguimiento" :key="remito.id">
					<td>
						<span v-if="remito.fecha"> {{remito.fecha.date.split('.')[0]}} </span>
					</td>
					<td>{{remito.operacion.split('|')[0]}}-{{remito.operacion.split('|')[1]}}-{{remito.operacion.split('|')[5]}}
					</td>
					<td>
						<span v-if="(remito.term == 9999) && (remito.sucursal == 90)">APP</span>
						<span v-if="!((remito.term == 9999) && (remito.sucursal == 90))">{{remito.suc}}</span>
					</td>
				</tr>
				<tr v-if="seguimiento.length === 0">
					<td colspan="3" style="text-align: center;">
						No se encontró información del seguimiento de la guía.
					</td>
				</tr>
			</tbody>
                          
		</table>
</template>

<script>

    export default {
        props: {
          seguimiento: {
            required: true
            },
          },
        name:"seguimiento",
        
    }
</script>

<style scoped>
  td {
      font-weight: 500 !important;
  }
</style>
